/* ------------------------------------------- vocabulário de movimento ---
   Um único lugar para as curvas e os quadros-chave da Trilha do Guru. O
   módulo é o único do produto com animação de RECOMPENSA (o resto do app se
   resolve com transições de estado), e sem um vocabulário comum cada tela
   inventaria a sua própria duração — três "pulsos" ligeiramente diferentes
   na mesma página é o que faz gamificação parecer amadora.

   Regra dos quadros-chave daqui: o estado FINAL é o estado BASE do elemento.
   Nenhuma regra base pode nascer com `opacity: 0` ou deslocada — quem
   desliga animação (ver `semMovimento`) tem que ver a tela inteira mesmo
   assim, e um `animation: none` sobre uma base invisível apagaria a
   interface. */
import {css, keyframes} from 'styled-components'

// Espelha os tokens de motion do design system (--motion-fast/base/slow e
// --motion-easing). O main-app ainda não consome o CSS do DS, então os
// valores moram aqui em vez de virarem números soltos em cada componente.
export const DURACAO = {
    rapida: '120ms',
    base: '200ms',
    lenta: '320ms',
} as const

export const SUAVE = 'cubic-bezier(0.2, 0.8, 0.2, 1)'
// Curva com passada além do alvo, reservada aos momentos de recompensa.
// Combina apenas com quadro-chave monotônico (`surgir`): sobre um que já tem
// pico próprio (`estourar`, `irradiar`), a passada se soma ao pico e vira
// quique duplo. Em transição de estado comum, faz a interface parecer
// instável — hoje o único uso é o balão "você está aqui" do mapa.
export const ELASTICA = 'cubic-bezier(0.34, 1.56, 0.64, 1)'

/* Preferência de sistema por menos movimento não é enfeite de
   acessibilidade: quem tem transtorno vestibular passa mal com paralaxe,
   giro e queda de confete. Some o movimento, fica o conteúdo — por isso
   `animation: none` é seguro (ver a regra dos quadros-chave). O `!important`
   existe porque várias animações daqui são interpoladas depois, dentro de
   blocos condicionais do styled-components. */
export const semMovimento = css`
    @media (prefers-reduced-motion: reduce) {
        animation: none !important;
        transition: none !important;
    }
`

// Entrada padrão: sobe um pouco e aparece. É o movimento mais usado do
// módulo — cards de resultado, balões, avisos.
export const surgir = keyframes`
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

// Entrada de recompensa: nasce pequeno, passa do tamanho e assenta.
export const estourar = keyframes`
    0% {
        opacity: 0;
        transform: scale(0.5);
    }
    60% {
        opacity: 1;
        transform: scale(1.12);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
`

// Erro. Curto e horizontal — o "não é por aí" universal.
export const tremer = keyframes`
    0%,
    100% {
        transform: translateX(0);
    }
    20% {
        transform: translateX(-6px);
    }
    40% {
        transform: translateX(5px);
    }
    60% {
        transform: translateX(-3px);
    }
    80% {
        transform: translateX(2px);
    }
`

// Halo que se abre atrás de uma conquista e some.
export const irradiar = keyframes`
    0% {
        opacity: 0.55;
        transform: scale(0.6);
    }
    100% {
        opacity: 0;
        transform: scale(1.9);
    }
`

// Confete: cai girando e desaparece antes de encostar na borda de baixo.
export const chover = keyframes`
    0% {
        opacity: 0;
        transform: translate3d(0, -10%, 0) rotate(0deg);
    }
    10% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: translate3d(0, 460px, 0) rotate(620deg);
    }
`

/* Barra que ESCOA (e não que enche) durante a espera do avanço automático:
   ver a faixa encurtando lê como "o tempo está acabando"; vendo-a crescer, a
   pessoa precisa deduzir o mesmo pelo caminho inverso. Linear de propósito —
   contagem de tempo com curva de aceleração mente sobre quanto falta. */
export const escoar = keyframes`
    from {
        transform: scaleX(1);
    }
    to {
        transform: scaleX(0);
    }
`
